/**
 * tweddi — Push Notifications Hook
 * Registers the service worker, requests permission, and sends
 * the push subscription to the backend.
 */
import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VAPID_PUBLIC_KEY = 'BAMFV0eLmXb3gbPhKP4aliPYN-y2SLE8ctnYEVdxwWjvyQkkfJq0T3onawk7aUKrOD6U0En_nN4GjJxoKyVP9TE';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export function usePushNotifications(user) {
  useEffect(() => {
    if (!user) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const register = async () => {
      try {
        // Register service worker
        const registration = await navigator.serviceWorker.register('/service-worker.js');
        await navigator.serviceWorker.ready;

        // Check existing subscription
        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
          // Request permission
          const permission = await Notification.requestPermission();
          if (permission !== 'granted') return;

          // Subscribe
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
          });
        }

        // Send subscription to backend
        await axios.post(`${API}/push/subscribe`, subscription.toJSON());
      } catch (err) {
        // Silently fail — push is a nice-to-have, not critical
        console.warn('Push registration failed:', err);
      }
    };

    register();
  }, [user?.id]);
}
